/**
 * Pre-compiled fr-FR messages for LoadingSpinner
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { default: `Chargement des données` };
